import { Form } from 'antd';
import React, { useEffect, useState } from 'react';
import Button from '../../../components/Button/Button';
import FormItem from '../../../components/FormItem/FormItem';
import Input from '../../../components/Input/Input';
import { useLocation, useNavigate  } from 'react-router-dom';

import styles from './ResetPassword.module.scss';
import { createErrorNotification, createSuccessNotification } from '../../../service/notification';

import { sendEmailToResetPassword, changePassword } from '../../../service/share';
import useHeader from '../../../hooks/useHeader';
import { delay } from '../../../utils/utils';

const isEmail = (value) => {
  const testEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)

  if (!testEmail) return false

  return true
}

const ResetPassword = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const location = useLocation()

  const [loading, setLoading] = useState(false);

  const sendedEmail = location.pathname.split('/')[2]
  const resetToken = location.pathname.split('/')[3]

  useHeader({ header: 'Recuperar Senha' });

  const GetToken = () => (
    <>
      <div>
        <h1 className={styles.title}>Recupere sua senha</h1>
      </div>
      <div className={styles.subtitle}>
        <span className={styles.subtitle}>
          Informe o e-mail associado à sua conta para alterar sua senha. Será enviado um e-mail com as informações para recuperação.
        </span>
      </div>
      <FormItem
        label="Email"
        name="email"
        required
        rules={[
          {
            required: true, message: 'Por favor, insira seu email!',
          },
        ]}
      >
        <Input
          style={styles.input}
          type="email"
        />
      </FormItem>
    </>

  )

  const ResetPassword = () => (
    <>
      <div>
        <h1 className={styles.title}>Alterar senha</h1>
      </div>
      <div className={styles.subtitle}>
        <span className={styles.subtitle}>
          Insira sua nova senha.
        </span>
      </div>
      <FormItem
        label="Senha"
        name="password"
        required
        rules={[
          {
            required: true, message: 'Por favor, insira sua senha!',
          },
        ]}
      >
        <Input
          style={styles.input}
          type="password"
        />
      </FormItem>
      <FormItem
        label="Confirmar Senha"
        name="confirmPassword"
        required
        dependencies={['password']}
        rules={[
          {
            required: true, message: 'Por favor, insira sua senha novamente!',
          },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue('password') === value) {
                return Promise.resolve();
              }
              return Promise.reject(new Error('Senhas não coincidem!'));
            },
          }),
        ]}
      >
        <Input
          style={styles.input}
          type="password"
        />
      </FormItem>
    </>
  )

  const renderItem = () => {
    if (resetToken) {
      return <ResetPassword />
    } 
    
    return <GetToken />
  };

  async function onFinish(payload){
    if(loading) return

    const { email, password, confirmPassword } = payload

    setLoading(true)

    if (password && resetToken) {
      const { error, success } = await changePassword(resetToken, sendedEmail, password, confirmPassword);

      if (error) {
        setLoading(false)

        return createErrorNotification('Ops, algo deu errado no cadastro. Tente novamente mais tarde.');
      }

      setLoading(false)

      createSuccessNotification('Senha alterada com sucesso!')

      await delay(2000)

      navigate('/login')
    }else{
      const { error, success } = await sendEmailToResetPassword(email);

      if(error) {
        setLoading(false)

        return createErrorNotification('Ops, algo deu errado no cadastro. Tente novamente mais tarde.');
      }

      setLoading(false)

      return createSuccessNotification('Enviado, visualize sua caixa de e-mail.')
    }
  }

  return(
    <div className={styles.container}>
      <div className={styles.maskContainer}></div>
        <div className={styles.createContainer}>
          <div className={styles.createForm}>
            <Form 
              layout="vertical" 
              onFinish={onFinish} 
              hideRequiredMark 
              id="formLogin" 
              className={styles.FormContainer}
            >
                {renderItem()}
                <Button loading={loading} submit style={styles.button}>Enviar</Button>
              </Form>
              <div className={styles.redirectLink}>
                Já tem uma conta? <a href="/login" className={styles.link}>Faça o login.</a>
              </div>
            </div>
        </div>
    </div>
  )
}

export default ResetPassword;